var _rect, _path, _g, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencySgd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136711)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136711)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1516_136711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: 0,
    width: 48,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8.01562 0H38.1066V30.6785H-8.01562V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1516_136711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.44922 0H42.4382V30.6785H-9.44922V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.44922 0H42.4382V15.3393H-9.44922V0Z",
    fill: "#DF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.129533 6.82468L0.408828 7.67967L-0.332158 7.15528L-1.06175 7.69107L-0.79385 6.82468L-1.52344 6.29459L-0.617153 6.28319L-0.332158 5.42821L-0.0471638 6.28319H0.853421L0.129533 6.82468ZM1.12702 9.78863L1.41201 10.6493L0.671024 10.1249L-0.0642628 10.655L0.209332 9.79433L-0.520255 9.25854L0.386029 9.25284L0.665324 8.39215L0.950319 9.24714H1.8623L1.12702 9.78863ZM4.46146 9.76583L4.74075 10.6322L3.99977 10.1021L3.27018 10.6322L3.53807 9.77153L2.80849 9.24144L3.71477 9.23004L3.99977 8.37505L4.28476 9.23004H5.18534L4.46146 9.76583ZM5.45324 6.82468L5.73254 7.68537L4.99155 7.16098L4.26196 7.69107L4.53556 6.83038L3.80027 6.29459L4.71225 6.28889L4.98585 5.42821L5.27084 6.28319H6.18283L5.45324 6.82468ZM2.81419 4.86962L3.09918 5.736L2.35819 5.20591L1.62291 5.7417L1.8965 4.87532L1.16692 4.33953L2.0675 4.33383L2.35249 3.47314L2.63749 4.32813H3.54947L2.81419 4.86962Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    stroke: "#E5E5E5",
    strokeWidth: 1.44114,
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136711"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136711"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.00391,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencySgd);
export default __webpack_public_path__ + "static/media/Currency=SGD.2ee8c2841bf2d7144329554c5f70de0e.svg";
export { ForwardRef as ReactComponent };